import { useUser } from "@src/api/user-auths/login";
import { setUserAlerts } from "@src/api/users/user-alerts";

/**
 * Whether something new is waiting on the Dashboard for this user: anything
 * that lands there sets it, and opening the Dashboard clears it.
 */
export const useUnseenOnDashboard = (): boolean => {
  const user = useUser();
  return (
    user.data?.type === "login" &&
    user.data.user.userAlerts?.unseenOnDashboard === true
  );
};

export const markDashboardSeen = () =>
  setUserAlerts({ unseenOnDashboard: false });
